// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".allergenselect-button {\n    margin: .2em;\n    width: 2.5em;\n    height: 2.5em;\n}\n\n.allergen-selected { }\n\n.allergen-selected:hover {\n    box-shadow: 0 0 0 0.2rem rgba(29, 43, 86, 0.5);\n}\n\n.allergen-not-selected { }\n\n.allergen-not-selected:hover {\n    box-shadow: 0 0 0 0.2rem rgba(29, 43, 86, 0.5);\n    color: black !important;\n    background-color: #fff !important;\n}\n", ""]);
// Exports
module.exports = exports;
